// extracted by mini-css-extract-plugin
module.exports = {"container":"GoalsEmptyState_container__azMRL","add-goal":"GoalsEmptyState_add-goal__14Tp3"};